// store/student/exam/store/_reducer.js
import * as types from './_actionTypes';

const initialState = {
  availableExams: [],
  currentExam: null,
  currentAttempt: null,
  questions: [],
  savedAnswers: {},
  currentAnswers: {},
  examInfo: null,
  results: null,
  examHistory: [],
  timeRemaining: null,
  autoSaveStatus: 'idle', // idle, saving, saved, error
  loading: false,
  error: null
};

const examReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get available exams
    case types.GET_AVAILABLE_EXAMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.GET_AVAILABLE_EXAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        availableExams: action.payload,
        error: null
      };
    case types.GET_AVAILABLE_EXAMS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Start exam
    case types.START_EXAM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.START_EXAM_SUCCESS: {
      const savedAnswersMap = {};
      if (action.payload.saved_answers) {
        action.payload.saved_answers.forEach(answer => {
          savedAnswersMap[answer.question_id] = answer.selected_answer;
        });
      }
      
      // Get time_remaining from backend if available
      const timeRemaining = action.payload.attempt?.time_remaining !== undefined 
        ? action.payload.attempt.time_remaining 
        : null;
      
      return {
        ...state,
        loading: false,
        currentAttempt: action.payload.attempt,
        questions: action.payload.questions,
        examInfo: action.payload.exam_info,
        savedAnswers: savedAnswersMap,
        currentAnswers: { ...savedAnswersMap },
        timeRemaining: timeRemaining,
        error: null
      };
    }
    case types.START_EXAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Save answer
    case types.SAVE_ANSWER_REQUEST:
      return {
        ...state,
        autoSaveStatus: 'saving'
      };
    case types.SAVE_ANSWER_SUCCESS:
      return {
        ...state,
        autoSaveStatus: 'saved',
        savedAnswers: {
          ...state.savedAnswers,
          [action.payload.question_id]: action.payload.selected_answer
        }
      };
    case types.SAVE_ANSWER_FAILURE:
      return {
        ...state,
        autoSaveStatus: 'error',
        error: action.payload
      };

    // Submit exam
    case types.SUBMIT_EXAM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.SUBMIT_EXAM_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
        currentAttempt: null,
        questions: [],
        currentAnswers: {},
        error: null
      };
    case types.SUBMIT_EXAM_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get exam results
    case types.GET_EXAM_RESULTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.GET_EXAM_RESULTS_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload,
        error: null
      };
    case types.GET_EXAM_RESULTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Get exam history
    case types.GET_EXAM_HISTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case types.GET_EXAM_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        examHistory: action.payload,
        error: null
      };
    case types.GET_EXAM_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Local state management
    case types.UPDATE_CURRENT_ANSWER:
      return {
        ...state,
        currentAnswers: {
          ...state.currentAnswers,
          [action.payload.questionId]: action.payload.answer
        }
      };

    case types.SET_EXAM_TIMER:
      return {
        ...state,
        timeRemaining: action.payload
      };

    case types.SET_AUTO_SAVE_STATUS:
      return {
        ...state,
        autoSaveStatus: action.payload
      };

    case types.RESET_EXAM_STATE:
      return {
        ...initialState,
        availableExams: state.availableExams,
        examHistory: state.examHistory
      };

    default:
      return state;
  }
};

export default examReducer;